export default __webpack_public_path__ + "static/media/ico-aws-vpc-circle-solid.bea221ce.svg";